module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Broadcasting__wrapper"
  }, [_c('div', {
    staticClass: "Broadcasting__body"
  }, [_c('div', {
    staticClass: "Broadcasting__body-container"
  }, [_c('div', {
    staticClass: "Broadcasting__inner"
  }, [_c('i', {
    staticClass: "Broadcasting__icon icon-ic_broadcast"
  }), _vm._v(" "), _c('div', {
    staticClass: "Broadcasting__status"
  }, [_vm._v("\n          Broadcast is on\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Broadcasting__credentials"
  }, [_c('div', {
    staticClass: "Broadcasting__credentials-item"
  }, [_c('i', {
    staticClass: "icon-ic_link Broadcasting__credentials-icon-link"
  }), _vm._v("\n            " + _vm._s(_vm.user.conferenceUrl) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "Broadcasting__credentials-item"
  }, [_c('i', {
    staticClass: "icon-ic_lock Broadcasting__credentials-icon-lock"
  }), _vm._v("\n            PIN  " + _vm._s(_vm.user.conferencePin) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "Broadcasting__main-actions"
  }, [_c('a', {
    staticClass: "Broadcasting__main-action-btn Broadcasting__main-action-btn--red",
    on: {
      "click": _vm.stop
    }
  }, [_vm._v("\n          stop broadcasting\n        ")])])])]), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": 'KingsConference - Broadcast'
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c0db09","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-menu/broadcasting-tab/broadcasting-tab.vue
// module id = 418
// module chunks = 1